import React from 'react'
import { LoadingButton, LoadingButtonProps } from '@mui/lab'

export type ChipButtonProps = Omit<LoadingButtonProps, 'variant'> & {
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component?: React.ElementType
  [k: string]: any
}

export const ChipButton = React.forwardRef(function ChipButton(props: ChipButtonProps, ref: React.Ref<HTMLButtonElement>) {
  const { color = 'inherit', children, sx = [], ...rest } = props
  return (
    <LoadingButton
      {...rest}
      ref={ref}
      color={color}
      variant="chip"
      sx={[
        {
          minWidth: 'unset',
          borderRadius: '6px',
          padding: '3px',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </LoadingButton>
  )
})

export default ChipButton
